// Simple array comparing functions, used in multiple dropdown component
// params:
//   - forceToArray - in case if one of the array is falsy (null, undefined, false) it converts it to empty array
//   - equalItems - optionally passed comparing function, returns 'true' if array items are equal
export var equalArrays = function equalArrays(array1, array2, forceToArray, sortArrays, equalItems) {
  if (forceToArray === void 0) {
    forceToArray = true;
  }

  if (sortArrays === void 0) {
    sortArrays = false;
  }

  if (equalItems === void 0) {
    equalItems = function equalItems(a, b) {
      return a === b;
    };
  }

  var a1 = array1;
  var a2 = array2;

  if (forceToArray) {
    a1 = a1 || [];
    a2 = a2 || [];
  }

  if (!a1 && !a2) {
    return true;
  }

  if (a1 && !a2 || !a1 && a2 || a1.length !== a2.length) {
    return false;
  }

  if (sortArrays) {
    a1 = [].concat(a1).sort();
    a2 = [].concat(a2).sort();
  }

  for (var i = 0; i < a1.length; i++) {
    if (a1[i] instanceof Array && a2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!equalArrays(a1[i], a2[i], forceToArray, sortArrays, equalItems)) {
        return false;
      }
    } else if (!equalItems(a1[i], a2[i])) {
      return false;
    }
  }

  return true;
};
export var uniqueArray = function uniqueArray(arr) {
  return arr.filter(function (item, i, arr) {
    return arr.indexOf(item) === i;
  });
};
export var intersectionArrays = function intersectionArrays(arr1, arr2) {
  return arr1.filter(function (x) {
    return arr2.includes(x);
  });
};
export var differenceArrays = function differenceArrays(arr1, arr2) {
  return arr1.filter(function (x) {
    return !arr2.includes(x);
  });
};